import angular from 'angular'
import MODULE_NAME from '../../app'

angular.module(MODULE_NAME).run(['appSettings', 'soTranslateSettings', 'onViewLabelsForLanguageFactory', function(appSettings, soTranslateSettings, onViewLabelsForLanguageFactory) {
	appSettings.setDefaultLanguage('ptBr');
	soTranslateSettings.setLabelsForLanguage(onViewLabelsForLanguageFactory.getLabels(appSettings.getDefaultLanguage()));
}]);



// WEBPACK FOOTER //
// ./src/app/scripts/configs/run.js